import React, { FC } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Container, Grid, Theme, Typography } from '@material-ui/core';
import ToggleAccordion from 'components/common/structures/Accordion/Toggle-Accordion';
import clsx from 'clsx';
import { Faq } from 'services/cms/types';

interface FaqToggleAccordionProps {
  faqs: Faq[];
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      backgroundColor: theme.palette.customColors.lightGray,
    },
    container: {
      paddingTop: theme.spacing(10),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(10, 20, 0),
        marginTop: 0,
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(20, 20, 0),
        marginTop: -theme.spacing(10),
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(35, 20, 0),
        marginTop: -theme.spacing(27),
      },
    },
    postAccordion: {
      marginBottom: theme.spacing(10),
      [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(16),
      },
    },
    title: {
      paddingBottom: theme.spacing(1),
      fontSize: 18,
      fontWeight: 700,
      color: theme.palette.secondary.main,
      [theme.breakpoints.up('sm')]: {
        fontSize: 24,
      },
    },
    lastBlock: {
      paddingBottom: 48,
    },
  };
});

const FaqToggleAccordion: FC<FaqToggleAccordionProps> = (props) => {
  const { faqs } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container className={classes.container}>
        {faqs.map(({ items, title }, index, origin) => (
          <Grid
            key={title}
            className={clsx(
              classes.postAccordion,
              index + 1 === origin.length && classes.lastBlock
            )}
          >
            <Typography className={classes.title}>{title}</Typography>
            {items.map(({ question, answer }) => (
              <ToggleAccordion key={question + answer} title={question} description={answer} />
            ))}
          </Grid>
        ))}
      </Container>
    </Box>
  );
};

export default FaqToggleAccordion;
